import { Box, Typography } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import SvgToIcon from "../../../../icons/SvgToIcon";
import { operationalHeatmap } from "../../../stack/environment/icons/iconExport";
import { getCoverageColor, getRiskColor } from "../utils";

const SubPillarSection = ({
  entityType,
  typeData,
  showRisk,
  setSelectedSubPillar,
  selectedSubPillar,
}) => {
  const colors = useColors();
  const isSelected = selectedSubPillar?.subPillar === typeData.subPillar;

  return (
    <Box
      onClick={() => setSelectedSubPillar(typeData)}
      sx={{
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        borderRadius: "10px",
        height: "60px",
        padding: "0px 8px",
        justifyContent: "center",
        boxShadow: isSelected
          ? "0px 0px 4px 0px " + colors.grey_48percent + " inset"
          : "none",
        backgroundColor: isSelected ? colors.common_white : "transparent",
        "&:hover": {
          backgroundColor: isSelected
            ? colors.common_white
            : colors.grey_5percent,
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Box
          sx={{
            width: "4px",
            height: "24px",
            borderRadius: "2px",
            padding: "2px",
            backgroundColor: showRisk
              ? getRiskColor(typeData.severity, colors)
              : getCoverageColor(typeData.severity, colors),
            transition: "transform 0.2s ease",
          }}
        />
        <SvgToIcon
          IconLogo={operationalHeatmap[typeData.subPillar]}
          style={{
            width: "24px",
            height: "24px",
          }}
        />

        <Typography
          variant="subtitle2"
          sx={{
            color: colors.text_primary,
          }}
        >
          {typeData.subPillar}
        </Typography>
      </Box>
    </Box>
  );
};

export default SubPillarSection;
